<template>
    <div class="comparing-img" v-on:mouseenter="loadImages">
        <div
            class="bg-ratio bg-ratio--4-3"
            :style="`background-image: url('${titleImage}')`"
        ></div>

        <div class="comparing-img__thumbs">
            <div v-if="!images" class="position-relative" style="height: 81px">
                <div class="loader show"></div>
            </div>
            <div v-else v-for="image in images"
                 class="bg-ratio bg-ratio--4-3 m-1"
                 :style="`background-image: url('${image}')`"
            ></div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "thumbnails-search",

        props: ['title', 'record', 'routeImages'],

        data: function () {
            return {
                images: null,
                fetching: false,
                titleImage: '/img/pdf/no-image.png',
            }
        },

        mounted: function() {
            let axios = require('axios')
            let self = this

            let config = {
                method: 'get',
                url: this.routeImages + '/' + this.record,
                headers: { }
            };

            axios(config)
                .then(function (response) {
                    self.titleImage = response.data[0]
                })
                .catch(function (error) {
                    console.log(error)
                })
        },

        methods: {
            loadImages: function () {
                if (!this.fetching) {
                    this.fetching = true

                    let axios = require('axios')
                    let self = this

                    let config = {
                        method: 'get',
                        url: this.routeImages + '/' + this.record,
                        headers: { }
                    };

                    axios(config)
                        .then(function (response) {
                            self.images = response.data.slice(1)
                        })
                        .catch(function (error) {
                            console.log(error)
                        })
                }
            }
        }
    }
</script>

<style scoped>
.loader {
    top: 20px;
    left: 50% !important;
    transform: translateX(-50%);
}
</style>
